<div class="dd-vehicle-card dd-card-radius">
  <mat-card class="dd-card-radius dd-card-height" [class.dd-card-zoom]="noLongerAvailable === false" fxLayout="column" (click)="noLongerAvailable == false && navigateToVehicleDetails()">
    <div fxLayout="row" fxLayoutAlign="space-between center" style="z-index:1;">
      <div fxLayout="column" fxLayoutAlign="start start" class="dd-model-year-name-trim">
        <div class="dd-model-year" innerHTML="{{sharedFunctionService.getFormattedYearMarketingName(vehicleDetails)}}"></div>
        <!-- <div class="dd-model-name" innerHTML="{{sharedFunctionService.getModelMarketingName(vehicleDetails)}}"></div> -->
        <!-- <div class="dd-model-trim" innerHTML="{{sharedFunctionService.getModelTrimName(vehicleDetails)}}"></div> -->
      </div>
      <div class="dd-card-count" [innerHTML]="cardNumber"></div>
    </div>
    <div class="dd-vin-text" fxLayout="row" style="z-index:1;">
      <div>VIN:</div>
      <div [innerHTML]="vehicleDetails?.vin"></div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <img height="120px" [src]="imgExterior" onerror="this.onerror=null; this.src='assets/icons/icon-no-image.svg'; this.style['margin-top']='0px';this.style['margin-bottom']='0px'; this.style['height']='74px';" style="margin-top: -20px; margin-bottom: -25px;">
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="column" class="dd-total-msrp">
        <div class="dd-value" *ngIf="vehicleDetails?.price?.totalMsrp !== 'N/A'">{{vehicleDetails?.price?.totalMsrp | currency: 'USD': true: '1.2' }}</div>
        <div class="dd-value" *ngIf="vehicleDetails?.price?.totalMsrp === 'N/A'">N/A</div>
        <div class="dd-text">Total Price (As built)</div>
      </div>
      <div class="dd-view-details">&nbsp;</div>
      <div fxLayout="column" class="dd-total-msrp" fxLayoutAlign="center end">
        <div class="dd-value" *ngIf="mpgDetails?.mpg?.cityMpg">{{mpgDetails?.mpg?.cityMpg}}/{{mpgDetails?.mpg?.highwayMpg}}</div>
        <div class="dd-value" *ngIf="mpgDetails?.mpge?.cityMpge">{{mpgDetails?.mpge?.cityMpge}}/{{mpgDetails?.mpge?.highwayMpge}}</div>
        <div class="dd-value" *ngIf="!mpgDetails?.mpg?.cityMpg && !mpgDetails?.mpge?.cityMpge">{{mpgDetails?.mpg?.combined}}/{{mpgDetails?.mpge?.combined}}</div>
        <div class="dd-text">Est.MPG</div>
      </div>
    </div>
    <div class="dd-card-radius dd-card-overlay" *ngIf="noLongerAvailable">
      <div class="dd-not-available-text">No Longer Available</div>
    </div>
    <div class="dd-card-radius dd-card-overlay" *ngIf="showLoading == true">
      <div class="dd-loading">
        <img src="../../../assets/icons/loader.svg" height="100px" alt="Loading...">
      </div>
    </div>
  </mat-card>
</div>
